import { NgTemplateOutlet } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, TemplateRef } from '@angular/core';
import { AccordionModule } from 'primeng/accordion';

@Component({
    selector: 'app-panel',
    standalone: true,
    imports: [AccordionModule, NgTemplateOutlet],
    templateUrl: './panel.component.html',
    styleUrls: ['./panel.component.scss'],
})
export class PanelComponent implements OnChanges {
    @Input({ required: true }) headerTitle!: string | TemplateRef<any>;
    @Input({ required: false }) collapsed = false;
    @Input({ required: true }) id = 'panel';
    @Output() isPanelCollapsed = new EventEmitter<boolean>();

    headerTemplate: TemplateRef<any> | null = null;
    selected: boolean = true;

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['headerTitle']) {
            this.computeHeaderTemplate();
        }
    }

    private computeHeaderTemplate() {
        if (typeof this.headerTitle === 'string') {
            this.headerTemplate = null;
        } else {
            this.headerTemplate = this.headerTitle;
        }
    }

    selectedChange(event: any): void {
        this.isPanelCollapsed.emit(!event);
    }
}
